export const ABOUND_EMAIL = "intermediaries@getabound.com";

export const INTERNAL_EMAIL_DOMAINS = [
  "getabound.com",
  "fintern.ai",
  "ahauz.com",
];

export const API_URL = import.meta.env.REACT_APP_API as string;

export const APP_URLS = {
  ACCOUNT: {
    ACCEPT_INVITE: "/account/accept-invite/:token",
    ACCOUNT_PROFILE: "/account/profile",
    RESET_PASSWORD: "/account/reset-password/:uidb64/:token",
    FORGOT_PASSWORD: "/account/forgot-password",
  },
  APPLICATION_FORM: "/application-form",
  CASE_MANAGEMENT: "/cases",
  CASE_DETAIL: "/cases/:caseId",
  CASE_TRACKER: "/case-tracker",
  CASE_TRACKER_DETAIL: "/case-tracker/:caseId",
  CASE_DOCUMENTS: "/cases/:caseId/documents",
  CASE_DEBT_CONSOLIDATION:
    "/cases/:caseId/application/:applicationId/debt-consolidation",
  DASHBOARD: "/",
  LOGIN: "/login",
  RESOURCES: "/resources",
};

export const WEB_URLS = {
  DOCUMENT_SERVER: import.meta.env.REACT_APP_DOCUMENT_SERVER as string,
  CONTACT: "https://aboundmortgages.ahauz.com/contact",
  POLICIES: {
    COOKIES: "https://aboundmortgages.ahauz.com/cookie-policy",
    PRIVACY: "https://aboundmortgages.ahauz.com/privacy-notice",
    TERMS: "https://aboundmortgages.ahauz.com/terms",
    COMPLAINTS: "https://aboundmortgages.ahauz.com/complaints",
  },
};

export const COOKIES = {
  CSRF: "__Secure-csrftoken",
};

export const FEATURE_FLAGS = {};

export const APP_TITLE = "Abound Intermediaries";
